export default __webpack_public_path__ + "static/media/clock.ac152541.svg";